import * as React from 'react';
import { Theme } from '@cian/ui-kit';
import { FavoriteButton } from '../../components/Favorite/FavoriteButton';
import { TopControls } from '../../components/TopControls';
import { FavoriteContainer } from '../Favorite';
import { NewbuildingCompareButton } from '../NewbuildingCompareButton';
import { NewbuildingReviewsStatContainer } from '../NewbuildingReviewsStat';

export function TopControlsContainer() {
  return (
    <TopControls
      compare={
        <Theme theme="onOverlay">
          <NewbuildingCompareButton withOnboarding={true} buttonTheme="stroke_secondary" source="header" />
        </Theme>
      }
      favorite={
        <Theme theme="onOverlay">
          <FavoriteContainer button={FavoriteButton} buttonTheme="stroke_secondary" buttonSize="M" />
        </Theme>
      }
      reviews={<NewbuildingReviewsStatContainer />}
    />
  );
}
